import React from "react";

const CertificateCard = ({ title, body, imgSrc }) => {
  return (
    <div className="rounded-3xl bg-white/5 backdrop-blur-md border border-white/10 w-full h-full p-6 flex flex-col justify-start shrink-0 shadow-xl hover:shadow-emerald-500/20 hover:-translate-y-2 transition-all duration-300 group">
      <div className="flex-grow flex items-center justify-center bg-black/20 rounded-2xl overflow-hidden mb-6 border border-white/5 p-4">
        {imgSrc === undefined ? (
          <div className="w-full h-full"></div>
        ) : (
          <img className="max-w-full max-h-64 object-contain rounded-xl drop-shadow-lg group-hover:scale-105 transition-transform duration-500" src={imgSrc} alt={title} />
        )}
      </div>
      <p className="text-2xl font-extrabold text-center text-white pb-2">{title}</p>
    </div>
  );
};

export default CertificateCard;